"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 1.3.0
 */
var core_1 = require("@angular/core");
var lodash_1 = require("lodash");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var operators_1 = require("rxjs/operators");
var of_1 = require("rxjs/observable/of");
var Observable_1 = require("rxjs/Observable");
var noop_1 = require("rxjs/util/noop");
var SisWfButtonComponent = /** @class */ (function () {
    function SisWfButtonComponent(formService) {
        this.formService = formService;
        this.workflowActions = [];
        this.onSelect = new core_1.EventEmitter();
    }
    Object.defineProperty(SisWfButtonComponent.prototype, "labelMessage", {
        get: function () {
            return this._labelMessage;
        },
        set: function (value) {
            if (value) {
                this._labelMessage = value;
                return;
            }
            this._labelMessage = 'de_actions';
        },
        enumerable: true,
        configurable: true
    });
    SisWfButtonComponent.prototype.selectAction = function (action) {
        var _this = this;
        if (lodash_1.isNil(action.getFormId())) {
            this.onSelect.next(action.getId());
            return;
        }
        this.formService
            .loadForm('', action.getFormId(), this.category)
            .pipe(operators_1.mapTo(action.getFormId()), operators_1.catchError(function (err) {
            if (err.status === 404) {
                console.warn("form with id " + action.getFormId() + " is deleted");
                return of_1.of(undefined);
            }
            return Observable_1.Observable.throw(err);
        }), operators_1.tap(function (formId) {
            if (lodash_1.isNil(formId)) {
                _this.onSelect.next(action.getId());
                return;
            }
            _this.formActions.openWorkflowPopup(_this.form, _this.category, '', formId, action.getId());
        }), operators_1.first())
            .subscribe(noop_1.noop, console.error);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisWfButtonComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisWfButtonComponent.prototype, "workflowActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisWfButtonComponent.prototype, "form", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisWfButtonComponent.prototype, "formActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisWfButtonComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], SisWfButtonComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisWfButtonComponent.prototype, "onSelect", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisWfButtonComponent.prototype, "labelMessage", null);
    SisWfButtonComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-wf-button',
            template: require('./sis-wf-button.component.html'),
        }),
        __metadata("design:paramtypes", [idm_dynamic_layout_interpreter_1.FormService])
    ], SisWfButtonComponent);
    return SisWfButtonComponent;
}());
exports.SisWfButtonComponent = SisWfButtonComponent;
//# sourceMappingURL=sis-wf-button.component.js.map